export default {
  URLS: {
	TASKS : '/kiosk/job/task/',
	MARK_FAVOURITE_TASK : '/kiosk/job/task/mark-favourite',
  },

};

